/* sb-dc-override.js — let the customer order past a blocking preflight issue.

   Before this, any "block" severity issue (resolution too low, text outside
   the safe area, empty text layer, art hidden under a pole pocket…) hard-
   disabled the approve button. That stopped real orders, so the customer now
   gets an explicit acknowledgement instead of a wall.

   What this does NOT touch: autoRelease. An acknowledged order still never
   skips review and goes straight to the production queue — the bundle keeps
   that strict on purpose. And it does not touch the cart module's technical
   refusals (variant not found, sold out, quantity outside the price table),
   which are not opinions about quality — those calls would simply fail.

   The checkbox is injected into the proof modal rather than built into the
   bundle, so the 647KB app file does not need rebuilding for copy tweaks. */
(function () {
  'use strict';

  var on = false;             // has the customer ticked the box for THIS design
  var lastKey = '';           // design fingerprint the tick belongs to

  window.__dcOverrideOn = function () { return on; };

  /* Which issues they are waiving, read from the proof modal itself — the
     bundle does not expose the issue list, and the DOM is the same source the
     customer is looking at. */
  function blockingIssues() {
    var out = [];
    document.querySelectorAll('.proof-issues li.is-block').forEach(function (li) {
      var b = li.querySelector('b');
      if (b) out.push((b.textContent || '').replace(/\s+/g, ' ').trim());
    });
    return out;
  }
  window.__dcOverrideIssues = function () { return on ? blockingIssues() : []; };

  /* Fingerprint the design so a tick does not silently carry over to a
     different design or size after the customer keeps editing. */
  function key() {
    try {
      var s = window.__dcSpec || (window.__dcApi && window.__dcApi.spec) || {};
      return [s.widthIn, s.heightIn, s.quantity, s.finishing, blockingIssues().join('|')].join('~');
    } catch (e) { return ''; }
  }

  function css() {
    if (document.getElementById('sbdc-ovr-css')) return;
    var st = document.createElement('style');
    st.id = 'sbdc-ovr-css';
    st.textContent = [
      '.sbdc-ovr{margin:14px 0 0;padding:13px 15px;border:1px solid #e0a93a;border-radius:10px;background:#fdf6e6}',
      '.sbdc-ovr h4{margin:0 0 6px;font-size:13.5px;font-weight:800;color:#7a5205}',
      '.sbdc-ovr p{margin:0 0 10px;font-size:12.5px;line-height:1.5;color:#5c4a22}',
      '.sbdc-ovr label{display:flex;gap:9px;align-items:flex-start;cursor:pointer;font-size:13px;line-height:1.45;color:#3a2f14;font-weight:600}',
      '.sbdc-ovr input{margin-top:2px;width:16px;height:16px;flex:0 0 auto;accent-color:#c8102e;cursor:pointer}'
    ].join('\n');
    document.head.appendChild(st);
  }

  function build() {
    var box = document.createElement('div');
    box.className = 'sbdc-ovr';
    box.id = 'sbdc-ovr';
    box.innerHTML =
      '<h4>Order anyway?</h4>' +
      '<p>The checks above found problems that usually mean a reprint — most often ' +
      'artwork that is too low resolution to print sharply at this size. We can still ' +
      'run the job exactly as designed, but we cannot reprint it for free if it comes ' +
      'out the way the check says it will.</p>' +
      '<label><input type="checkbox" id="sbdc-ovr-cb">' +
      '<span>I understand the issues above and want to order it as it is.</span></label>';
    box.querySelector('#sbdc-ovr-cb').addEventListener('change', function (e) {
      on = !!e.target.checked;
      lastKey = key();
      // Nudge React into recomputing canApprove: a no-op spec write, no history.
      try {
        var a = window.__dcApi, s = a && a.spec;
        if (a && a.setSpec && s) {
          a.setSpec({ widthIn: s.widthIn, heightIn: s.heightIn, finishing: s.finishing,
                      quantity: s.quantity, material: s.material, __dcProd: s.__dcProd }, false);
        }
      } catch (err) {}
    });
    return box;
  }

  /* An empty canvas cannot be waived. The bundle's canApprove is

         (blocking === 0 || __dcOverrideOn()) && layers.length > 0

     so with nothing on the board the approve button stays disabled however
     the box is ticked. Showing a checkbox that does nothing when clicked is
     worse than showing none - the customer ticks it, waits, and concludes the
     page is broken. 2026-09-06: the only blocking finding left for a blank
     design is "The design is empty", so this was most of what the box did.
     Now they see that one line and go back and put something on the canvas. */
  function nothingToPrint() {
    try {
      var a = window.__dcApi;
      return !a || !a.doc || !(a.doc.layers || []).length;
    } catch (e) { return false; }              // 모르겠으면 지금까지 하던 대로
  }

  function tick() {
    var issues = document.querySelector('.proof-issues');
    var blocking = document.querySelectorAll('.proof-issues li.is-block').length;
    var existing = document.getElementById('sbdc-ovr');

    if (!issues || !blocking || nothingToPrint()) {     // nothing to waive
      if (existing) existing.parentNode.removeChild(existing);
      if (on) { on = false; lastKey = ''; }
      return;
    }
    // The design changed under a ticked box — make them look again.
    if (on && key() !== lastKey) {
      on = false;
      var cb = document.getElementById('sbdc-ovr-cb');
      if (cb) cb.checked = false;
    }
    if (!existing) {
      css();
      issues.parentNode.insertBefore(build(), issues.nextSibling);
    }
  }

  var mo = new MutationObserver(tick);
  function start() {
    mo.observe(document.body, { childList: true, subtree: true });
    tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('pagehide', function () { mo.disconnect(); });
})();
